<template>
  <b-col lg="12">
    <h1 v-if="title">
      {{ title }}
    </h1>
    <h1 v-else-if="$route.meta && $route.meta.label">
      {{ $route.meta.label }}
    </h1>
    <h1 v-else>
      {{ $route.name }}
    </h1>
    <hr>
  </b-col>
</template>

<script>
  export default {
    name: 'PageTitle',
    props: {
      title: {
        type: String
      }
    }
  }
</script>
